export default "__VITE_ASSET__f857ae7a__"